import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-server-link',
  templateUrl: './server-link.component.html',
  styleUrls: ['./server-link.component.css']
})
export class ServerLinkComponent {
  @Input() showServers: () => void = () => { };
  @Input() serverCount: number = 19;
  @Input() serverName: string = 'Hong Kong VIP2';


  getCountryFlag(serverName: string): string {
    const countryCodeMatch = serverName.match(/-(\w+)/i);
    const countryCode = countryCodeMatch ? countryCodeMatch[1].toUpperCase() : '';

    const flagMap: Record<string, string> = {
      'US': '🇺🇸',
      'JP': '🇯🇵',
      'SG': '🇸🇬',
      'HK': '🇭🇰',
      'TW': '🇹🇼',
      'DE': '🇩🇪',
    };

    return flagMap[countryCode] || '🇭🇰';
  }
} 